import type { IconProps } from '../types/IconProps.ts';
export const Activity: IconProps = {
    name: 'Activity',
    children: [
        `<path d="M3 12h2.42a.1.1 0 0 0 .1-.08l2.4-9.57c.02-.1.16-.1.18 0l5.81 19.37c.03.09.16.1.2 0l3.62-9.66a.1.1 0 0 1 .09-.06H21" />`,
    ]
};